module.exports = __webpack_public_path__ + "img/mobile-neck-9_26x550.8cde8af6.png";